import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileMetadata } from "@models/ui-models/files";
import {
  NgbAccordionBody,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem,
  NgbAccordionToggle,
  NgbTooltip
} from "@ng-bootstrap/ng-bootstrap";
import { FileLabelComponent } from "@shared/components/commons/file-label/file-label.component";

@Component({
  selector: 'app-documents-list-accordion',
  standalone: true,
  imports: [
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionCollapse,
    NgbAccordionBody,
    FileLabelComponent,
    NgbTooltip,
    NgbAccordionToggle,
  ],
  templateUrl: 'documents-list-accordion.component.html',
  styleUrl: 'documents-list-accordion.component.scss',
})
export class DocumentsListAccordionComponent {
  @Input() label = '';
  @Input() tip = '';
  @Input() initialClosed = true;
  @Input() noDocsPlaceholder = 'No documents';
  @Input() documents: FileMetadata[] | null = null;
  @Input() hideDeleteBtn = false;
  @Input() hideDownloadBtn = false;

  @Output() deleteFile = new EventEmitter<FileMetadata>();
  @Output() downloadFile = new EventEmitter<FileMetadata>();

  onDownloadFile(file: FileMetadata): void {
    this.downloadFile.emit(file);
  }

  onDeleteFile(file: FileMetadata): void {
    this.deleteFile.emit(file);
  }
}
